export default __webpack_public_path__ + "static/media/cat-6.7b0936ff.svg";